import React from 'react'
import { Badge, Button, Checkbox } from '../../../ui'
import { AlertTriangle, Check } from 'lucide-react'
import { coberturaDeFamilia, resumenCobertura } from '../../../../lib/planCobertura'

// Misma forma que VistaGrupos: aviso de faltantes en vez de vinculo vivo, y un
// grupo (aqui familia) sin jugadores inscritos no se pinta en verde.
const VistaFamilias = ({
  familias, jugadoresDeFamilia, planId = null, planesDe = {},
  seleccion = new Set(), onToggle, onAsignarFaltantes,
}) => (
  <ul className="divide-y divide-border">
    {familias.map((f) => {
      const c = coberturaDeFamilia({ jugadoresDeFamilia: jugadoresDeFamilia[f.id] || [], planId, planesDe })
      const seleccionable = c.inscritos > 0
      return (
        <li
          key={f.id}
          onClick={() => seleccionable && onToggle(f.id)}
          className={`flex min-h-11 items-start gap-3 rounded-md px-1 py-3 ${
            seleccionable ? 'cursor-pointer hover:bg-muted/50' : ''
          }`}
        >
          <div onClick={(e) => e.stopPropagation()}>
            <Checkbox
              checked={seleccion.has(f.id)}
              onCheckedChange={() => onToggle(f.id)}
              aria-label={`Seleccionar ${f.nombre}`}
              disabled={!seleccionable}
            />
          </div>
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-medium">{f.nombre}</p>
            <p className="text-xs text-muted-foreground">
              {resumenCobertura(c, { planId, sustantivo: 'jugadores inscritos' })}
            </p>
          </div>
          {c.faltantes.length > 0 && (
            <Button
              variant="outline"
              size="sm"
              className="shrink-0"
              onClick={(e) => { e.stopPropagation(); onAsignarFaltantes(f.id, c.faltantes) }}
              title={`Asignar el plan a los ${c.faltantes.length} que aún no lo tienen`}
            >
              <AlertTriangle className="mr-1 h-3.5 w-3.5" />
              Asignar a {c.faltantes.length}
            </Button>
          )}
          {c.completo && (
            <Badge variant="secondary" className="shrink-0">
              <Check className="mr-1 h-3 w-3" />Completo
            </Badge>
          )}
        </li>
      )
    })}
    {familias.length === 0 && (
      <li className="py-8 text-center text-sm text-muted-foreground">
        No hay familias con jugadores inscritos en esta temporada.
      </li>
    )}
  </ul>
)

export default VistaFamilias
